import { render, staticRenderFns } from "./work-exp.vue?vue&type=template&id=04a0337a"
import script from "./work-exp.vue?vue&type=script&lang=js"
export * from "./work-exp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports